import React from "react";
import styles from "../../_css/UI.module.css";

/**
 * ToggleButton
 * @param {Array<string>} options - Array of option labels (2 or more)
 * @param {string} value - Currently selected option
 * @param {function} onChange - Callback when selection changes (newValue) => void
 * @param {string} [className] - Optional extra className
 */
const ToggleButton = ({ options, value, onChange, className = "" }) => {
  return (
    <div className={`${styles.toggleButtonGroup} ${className}`}>
      {options.map((option, idx) => (
        <button
          key={option}
          type="button"
          className={
            value === option
              ? `${styles.toggleBtn} ${styles.active}`
              : styles.toggleBtn
          }
          onClick={() => onChange(option)}
        >
          {option}
        </button>
      ))}
    </div>
  );
};

export default ToggleButton; 